import React from 'react';
import GraphContainer from './GraphContainer';
import GraphHeader from './GraphHeader';
import GraphControlPanel from './GraphControlPanel';

const TreeBody = ({ cy }) => {
  return (
    <div id="graph-content">
      <GraphHeader cy={cy} />
      <GraphContainer cy={cy} />
      <GraphControlPanel cy={cy} />
    </div>
  );
};

export default TreeBody;
